module.exports = __webpack_public_path__ + "assets/img/logo-cynosure-academy.c92feabc.png";